import { useConfig } from '../../../ConfigContext';
import { multipleLayouts, multipleLayoutsH } from '../../../../glassConsts';

const LayoutSetter = () => {
  const {
    general,
    setGeneralState,
    selectedLayout,
    setSelectedLayout,
    setMultipleConfigState,
    multipleTextConfig,
  } = useConfig();

  return (
    <>
      <div className="flex items-center gap-2 mt-1">
        <label
          className="inline-flex items-center me-5 cursor-pointer"
          htmlFor="sound-like-checkbox"
        >
          <input
            type="checkbox"
            value=""
            className="sr-only peer"
            id="sound-like-checkbox"
            checked={multipleTextConfig.useText}
            onChange={(e) =>
              setMultipleConfigState({ useText: e.target.checked })
            }
          />
          <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-focus:ring-4 peer-focus:ring-purple-300 dark:peer-focus:ring-purple-800 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-purple-600 dark:peer-checked:bg-purple-600"></div>
          <span className="ms-3 text-md font-medium">Zobrazit text</span>
        </label>
      </div>
      {multipleTextConfig.useText && (
        <div>
          <label className="custom-label">Text</label>
          <input
            className={`w-full p-2`}
            value={multipleTextConfig.text}
            onChange={(e) => setMultipleConfigState({ text: e.target.value })}
            placeholder="Zadejte hlavní text"
          />
        </div>
      )}
      <div className="flex items-center gap-2 mt-1">
        <label
          htmlFor="orientation-checkbox"
          className="custom-label inline-flex items-center me-5 cursor-pointer"
        >
          <input
            id="orientation-checkbox"
            type="checkbox"
            className="sr-only peer"
            checked={general.orientationHorizontal}
            onChange={(e) =>
              setGeneralState({ orientationHorizontal: e.target.checked })
            }
          />
          <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-focus:ring-4 peer-focus:ring-purple-300 dark:peer-focus:ring-purple-800 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-purple-600 dark:peer-checked:bg-purple-600"></div>
          <span className="ms-3 text-md font-medium">Na výšku / na šířku</span>
        </label>
      </div>
      <div className="flex flex-wrap justify-center">
        {(general.orientationHorizontal
          ? multipleLayoutsH
          : multipleLayouts
        ).map((layout, index) => (
          <div
            key={index}
            className="layout-setter mr-2 mt-2"
            style={{
              backgroundColor:
                selectedLayout.name === layout.name ? '#bf3fff' : '',
            }}
            onClick={() => setSelectedLayout(layout)}
          >
            {layout.svg}
          </div>
        ))}
      </div>
    </>
  );
};

export default LayoutSetter;
